import { createClient } from '@sanity/client';

// CRA requires env vars to start with REACT_APP_
export const sanityClient = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: process.env.REACT_APP_SANITY_DATASET || 'production',
  apiVersion: '2025-11-27',
  useCdn: true,
});
